import { memo } from 'react'
import { Stack, Subheader3, TextField, Tooltip } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getSelectedTenant, getSelectedUser } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import SelectedUser from '../SelectedUser'
import SearchUserInput from '../SearchUserInput'

interface DestinationUserProps {
  contentSharingType: ContentSharingModelType
}

const DestinationUser: React.FC<DestinationUserProps> = ({ contentSharingType }) => {
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))
  const selectedUser = useSelector((state) => getSelectedUser(state, { contentSharingType }))

  const selectUserTitle = contentSharingType === ContentSharingModelType.ForReview ? 'Reviewer' : 'Session Owner'
  const isMergeForReview = contentSharingType === ContentSharingModelType.MergeForReview
  const isIgnoreContentOwner = selectedTenant?.IsSearchTargetContentByTenantEnabled
  const isVisible = selectedTenant?.Id && !(isMergeForReview && isIgnoreContentOwner)

  if (!isVisible) {
    return null
  }

  return (
    <Stack>
      <Subheader3>{selectUserTitle}</Subheader3>
      {selectedUser?.IsPredefined ? (
        <Tooltip text={selectedUser.Name}>
          <TextField value={selectedUser.Name} disabled />
        </Tooltip>
      ) : (
        <>
          <SelectedUser contentSharingType={contentSharingType} />
          <SearchUserInput contentSharingType={contentSharingType} />
        </>
      )}
    </Stack>
  )
}

export default memo(DestinationUser)

